import styled from 'styled-components';

import Column from '@sdk/components/ui/spacing/Column';
import Row from '@sdk/components/ui/spacing/Row';

import { REDESIGNED_LOGIN_BG_COLOR } from '@sdk/login/constants';

export const Container = styled(Row)`
  background: ${REDESIGNED_LOGIN_BG_COLOR};
  align-items: center;
  justify-content: center;
  overflow: auto;
`;

export const GrowRow = styled(Row)`
  flex: 1;
  align-items: center;
  column-gap: 10vw;
`;

export const SpaceBetween = styled(Row)`
  width: 100%;
  justify-content: space-between;
`;

export const InnerContainer = styled(Column)`
  position: relative;
  box-sizing: border-box;
  padding: 30px;
  height: 100vh;
  width: 100%;
  justify-content: center;
  align-items: center;
`;
